"use client"

import { useAppSelector } from "@/hooks/redux"
import { Skeleton } from "antd"

const ProductLabelSkeleton = () => {
  const productLabelSetting = useAppSelector(state => state.store.store_setting.data.product_labels)
  
  return (
    <Skeleton
      paragraph={false}
      styles={{
        title: {
          height: `${productLabelSetting.size / 10}rem`,
          marginBottom: '1rem',
          marginTop: '2rem',
          width: '15rem'
        }
      }}
    />
  )
}

export default ProductLabelSkeleton